import { ReactNode, Suspense, forwardRef, lazy } from 'react'

import {
  AgGridColumnProps,
  AgGridColumnType,
  AgGridReactProps,
  AgGridReactType,
} from '../types'

const LazyAgGridReact = lazy(() => import('./AgGridReact'))

type Props = AgGridReactProps & {
  children?: ReactNode
}

export const AgGridReact = forwardRef<AgGridReactType, Props>((props, ref) => (
  <Suspense fallback={<div>Loading Table</div>}>
    <LazyAgGridReact ref={ref} {...props} />
  </Suspense>
))

const LazyAgGridColumn = lazy(() => import('./AgGridColumn'))

export const AgGridColumn = forwardRef<AgGridColumnType, AgGridColumnProps>(
  (props, ref) => (
    <Suspense fallback={null}>
      <LazyAgGridColumn ref={ref} {...props} />
    </Suspense>
  ),
)
